import { render } from "./ClientJwtBearerComponent.vue?vue&type=template&id=84a45622"
import script from "./ClientJwtBearerComponent.vue?vue&type=script&lang=js"
export * from "./ClientJwtBearerComponent.vue?vue&type=script&lang=js"

import "./ClientJwtBearerComponent.vue?vue&type=style&index=0&id=84a45622&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__